module.exports = "/assets/69402c8c6156bef1d91886b9143bddd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TN.png
// module id = 2982
// module chunks = 0